export default __webpack_public_path__ + "static/media/1_10_hl.afae97f1.png";